(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[267],{

/***/ 32748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/post/index.js
var post = __webpack_require__(81449);
;// CONCATENATED MODULE: ./pages/offshore/articles/[...slug]/data.json
var data_namespaceObject = JSON.parse('{"guide_link":[{"chosenPost":4457,"title":"Ready to start your business in Delaware?","description":"Download your guide to uncover insights and make the right decisions","img":{"src":"/assets/images/offshore/articles/guide-delaware-post.png","width":339,"height":314},"dataForm":"ebook_delaware"},{"chosenPost":1082,"title":"Ready to start your offshore business?","description":"Brave new markets the right way with this handbook for going offshore","img":{"src":"/assets/images/offshore/articles/guide-offshore-post.png","width":322,"height":309},"dataForm":"ebook_offshore"}],"special_layout":[{"chosenPost":1225,"width":526,"height":398,"imgSrc":"/assets/images/offshore/articles/setting_business-offshore-post.png","imgAlt":"offshore-company-and-how-it-works"},{"chosenPost":6456,"width":497,"height":370,"imgSrc":"/assets/images/offshore/articles/explained-offshore-post.png","imgAlt":"economic-substance-rules"},{"chosenPost":11491,"width":457,"height":375,"imgSrc":"/assets/images/offshore/articles/legal_structure-offshore-post.png","imgAlt":"how-to-choose-business-structure"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/articles/[...slug]/index.js




var specialBLogs = ["offshore-company-and-how-it-works", "how-to-choose-business-structure", "economic-substance-rules", "starting-an-online-business-in-the-uk-for-beginners", "steps-to-registering-a-company", "best-offshore-company-jurisdictions"];
var haveEbook = ["offshore-company-and-how-it-works"];
var hiddenFeatureImgBlogs = ["/economic-substance-rules", "/starting-an-online-business-in-the-uk-for-beginners", "/offshore-company-and-how-it-works", "/steps-to-registering-a-company", "/how-to-choose-business-structure", "/a-guide-to-bvi-economic-substance-requirements", "/benefits-of-offshore-bank-accounts", "/best-offshore-company-jurisdictions"];
var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "offshore",
      page: data === null || data === void 0 ? void 0 : data.page.seo_string,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(post/* default */.Z, {
        data: data,
        dataJson: data_namespaceObject,
        specialLayout: specialBLogs.some(function (item) {
          return data.post.uri.includes(item);
        }),
        haveEbook: haveEbook.some(function (item) {
          return data.post.uri.includes(item);
        }),
        hiddenFeatureImg: hiddenFeatureImgBlogs.some(function (item) {
          return data.post.uri.includes(item);
        })
      })
    })
  });
}

/***/ }),

/***/ 90176:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/articles/[...slug]",
      function () {
        return __webpack_require__(32748);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,7915,1837,4090,9738,7447,2314,9156,6146,2888,179], function() { return __webpack_exec__(90176); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);